import { render, staticRenderFns } from "./OrderDetailMixed.vue?vue&type=template&id=31c8fef9&scoped=true&"
import script from "./OrderDetailMixed.vue?vue&type=script&lang=js&"
export * from "./OrderDetailMixed.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailMixed.vue?vue&type=style&index=0&id=31c8fef9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8fef9",
  null
  
)

export default component.exports